<template>
  <div class="explain-root">
    <img class="explain-img" :src="imgsrc">
    <div class="explain-close" @click="goBack()"></div>
  </div>

</template>

<script>
  export default {
    name: 'Index',
    data () {
      return {
        imgsrc: ''
      }
    },
    created() {
      const article = this.$route.query.article
      this.imgsrc = require(`../assets/result/${article}/translation${article}.png`)
    },
    methods: {
      goBack() {
        history.go(-1)
      }
    }
  }
</script>
<style scoped>
  .explain-root{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    background: url('../assets/result/bg.png');
  }
  .explain-img{
    width: 100%;
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
  }
  .explain-close{
    position: absolute;
    top:20px;
    right:20px;
    background: url("../assets/delete.png");
    background-size: cover;
    width: 32px;
    height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Explain.vue